export default "__VITE_ASSET__075f3c48__"